import { Divider, Grid2, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import {
	Control,
	Controller,
	UseFormSetValue,
	useWatch,
} from "react-hook-form";
import { Product } from "@/shared/models/Product";
import { parseNumberInput } from "@/shared/utils/parseNumberInput";

type Props = {
	control: Control<Product>;
	setValue: UseFormSetValue<Product>;
	disabled: boolean;
};

const SectionHeader = ({ title }: { title: string }) => (
	<Grid2 size={{ xs: 12 }}>
		<Typography
			variant="subtitle2"
			fontWeight={600}
			color="primary"
			sx={{ mb: 0.5, mt: 1 }}
		>
			{title}
		</Typography>
		<Divider />
	</Grid2>
);

export const WaxSpecsFields = ({ control, setValue, disabled }: Props) => {
	const bundleCol = useWatch({ control, name: "BundleCol" });
	const bundleRow = useWatch({ control, name: "BundleRow" });

	useEffect(() => {
		const col = bundleCol ?? 0;
		const row = bundleRow ?? 0;
		const count = col && row ? col * row : null;
		setValue("BundleCount", count, { shouldDirty: true });
	}, [bundleCol, bundleRow, setValue]);

	return (
		<>
			{/* Bundle Configuration */}
			<SectionHeader title="Bundle Configuration" />
			<Grid2 size={{ xs: 4, md: 1.7 }}>
				<Controller
					name="BundleCol"
					control={control}
					render={({ field }) => (
						<TextField
							label="Columns"
							type="number"
							value={field.value ?? ""}
							onChange={(e) =>
								field.onChange(
									parseNumberInput(e.target.value, { integer: true, min: 1 }),
								)
							}
							fullWidth
							size="small"
							disabled={disabled}
							inputProps={{ min: 1, step: 1 }}
						/>
					)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 4, md: 1.7 }}>
				<Controller
					name="BundleRow"
					control={control}
					render={({ field }) => (
						<TextField
							label="Rows"
							type="number"
							value={field.value ?? ""}
							onChange={(e) =>
								field.onChange(
									parseNumberInput(e.target.value, { integer: true, min: 1 }),
								)
							}
							fullWidth
							size="small"
							disabled={disabled}
							inputProps={{ min: 1, step: 1 }}
						/>
					)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 4, md: 2 }}>
				<Controller
					name="BundleCount"
					control={control}
					render={({ field }) => (
						<TextField
							label="Count"
							type="number"
							value={field.value ?? ""}
							fullWidth
							size="small"
							disabled
						/>
					)}
				/>
			</Grid2>
			<Grid2 size={{ xs: 4, md: 2.5 }}>
				<Controller
					name="StickSize"
					control={control}
					render={({ field }) => (
						<TextField
							label="Stick Size"
							value={field.value || ""}
							onChange={field.onChange}
							fullWidth
							size="small"
							disabled={disabled}
						/>
					)}
				/>
			</Grid2>
		</>
	);
};
